module.exports = __webpack_public_path__ + "static/media/95.f67ccf4a.jpg";